import { FormControl, FormControlProps } from "@material-ui/core";

export const Group = (props: Omit<FormControlProps, "fullWidth">) => {
    return (
        <FormControl fullWidth {...props} />
    );
};
